import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_LEGACY_CHIPS_DEFAULT_OPTIONS } from '@angular/material/legacy-chips';
import { MAT_LEGACY_SELECT_CONFIG } from '@angular/material/legacy-select';

import { ConfirmDialog, FileUploadDialog } from '@mode/shared/contract-common';
import { ConfirmDialogService, DatePickerComponent, FileUploadDialogService, SelectWithSearchComponent } from '..';
import { AnimatedRefreshIconComponent } from './animated-refresh-icon/animated-refresh-icon.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ClipboardDirective } from './clipboard/clipboard.directive';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { DialogLoadingViewComponent } from './dialog-loading-view/dialog-loading-view.component';
import { MdcDialogService } from './dialog/mdc-dialog.service';
import { MdcDialogHeaderComponent } from './dialog/mdc-header/mdc-dialog-header.component';
import { EmptyComponent } from './empty/empty.component';
import { FlatTableNgComponent } from './flat-table-ng/flat-table-ng.component';
import { LabeledMenuComponent } from './labeled-menu/labeled-menu.component';
import { NewContainerMenuComponent } from './new-container-menu/new-container-menu.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { PublishBadgeIconComponent } from './publish-badge-icon/publish-badge-icon.component';
import { ReportTypeIconComponent } from './report-type-icon/report-type-icon.component';
import { SimpleErrorComponent } from './simple-error/simple-error.component';
import { SortSettingsDialogComponent } from './sort-settings-dialog/sort-settings-dialog.component';
import { SortSettingsModalDialogService } from './sort-settings-dialog/sort-settings-dialog.service';
import { SqlNoResultsMessageComponent } from './sql-no-results-message/sql-no-results-message.component';
import { StateIndicatorIconComponent } from './state-indicator-icon/state-indicator-icon.component';
import { TableLoadingComponent } from './table-loading/table-loading.component';
import { TimeAgoComponent } from './time-ago/time-ago.component';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import { WorkspaceAvatarComponent } from './workspace-avatar/workspace-avatar.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FileUploadDialogComponent } from './file-upload/file-upload-dialog.component';

@NgModule({
  imports: [
    MatDialogModule,
    AnimatedRefreshIconComponent,
    BreadcrumbsComponent,
    ClipboardDirective,
    ConfirmDialogComponent,
    DatePickerComponent,
    MdcDialogHeaderComponent,
    DialogLoadingViewComponent,
    EmptyComponent,
    FlatTableNgComponent,
    NewContainerMenuComponent,
    PaginatorComponent,
    ReportTypeIconComponent,
    PublishBadgeIconComponent,
    SelectWithSearchComponent,
    SimpleErrorComponent,
    SqlNoResultsMessageComponent,
    StateIndicatorIconComponent,
    TableLoadingComponent,
    TimeAgoComponent,
    ToggleSwitchComponent,
    WorkspaceAvatarComponent,
    SortSettingsDialogComponent,
    LabeledMenuComponent,
    FileUploadComponent,
    FileUploadDialogComponent,
  ],
  exports: [
    AnimatedRefreshIconComponent,
    BreadcrumbsComponent,
    ClipboardDirective,
    ConfirmDialogComponent,
    DatePickerComponent,
    MdcDialogHeaderComponent,
    DialogLoadingViewComponent,
    EmptyComponent,
    FlatTableNgComponent,
    NewContainerMenuComponent,
    PaginatorComponent,
    ReportTypeIconComponent,
    PublishBadgeIconComponent,
    SimpleErrorComponent,
    SqlNoResultsMessageComponent,
    StateIndicatorIconComponent,
    TableLoadingComponent,
    TimeAgoComponent,
    ToggleSwitchComponent,
    WorkspaceAvatarComponent,
    SelectWithSearchComponent,
    SortSettingsDialogComponent,
    LabeledMenuComponent,
    FileUploadComponent,
    FileUploadDialogComponent,
  ],
  providers: [
    ConfirmDialogService,
    MdcDialogService,
    SortSettingsModalDialogService,
    {
      provide: MAT_LEGACY_CHIPS_DEFAULT_OPTIONS,
      useValue: {
        separatorKeyCodes: [COMMA, ENTER, SPACE],
      },
    },
    [{ provide: MAT_LEGACY_SELECT_CONFIG, useValue: { disableOptionCentering: true } }],
    [{ provide: Window, useValue: window }],
    [{ provide: ConfirmDialog, useExisting: ConfirmDialogService }],
    [{ provide: FileUploadDialog, useClass: FileUploadDialogService }],
  ],
})
export class SharedUiModule {}
